import * as React from "react";
import type { SVGProps } from "react";
const SvgCog = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-1.5 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.134 3.84a2 2 0 0 0-.732 2.732A1.62 1.62 0 0 1 4 9.001a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2 1.62 1.62 0 0 1 1.402 2.428 2 2 0 0 0 .732 2.732l1.732 1a2 2 0 0 0 2.732-.732 1.62 1.62 0 0 1 2.804 0 2 2 0 0 0 2.732.732l1.732-1a2 2 0 0 0 .732-2.732A1.62 1.62 0 0 1 20 15a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2 1.62 1.62 0 0 1-1.402-2.429 2 2 0 0 0-.732-2.732l-1.732-1a2 2 0 0 0-2.732.732 1.62 1.62 0 0 1-2.804 0 2 2 0 0 0-2.732-.732zm.567 1.982a.5.5 0 0 1 .183-.683l1.732-1a.5.5 0 0 1 .683.183c1.2 2.08 4.202 2.08 5.402 0a.5.5 0 0 1 .683-.183l1.732 1a.5.5 0 0 1 .183.683c-1.2 2.08.3 4.679 2.701 4.679a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5c-2.4 0-3.901 2.599-2.701 4.678a.5.5 0 0 1-.183.683l-1.732 1a.5.5 0 0 1-.683-.183c-1.2-2.08-4.202-2.08-5.402 0a.5.5 0 0 1-.683.183l-1.732-1a.5.5 0 0 1-.183-.683c1.2-2.08-.3-4.678-2.701-4.678a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5c2.4 0 3.901-2.6 2.701-4.679"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCog;
